var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-frame',{ref:"popup"},[_c('div',{class:_vm.$style.login},[_c('bind-form',{ref:"form",attrs:{"login-type":_vm.loginType},on:{"bind-success":_vm.handleBindSuccess}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }